import { Box } from "@mui/material";
import { type BoxRegion } from "components/Document/ReviewInteraction";

/** One region, drawn over the page as a soft rectangle with a tag naming it. */
export function RegionOutline({
  region,
  label,
  outlineRef,
}: {
  region: BoxRegion;
  label?: string;
  /** Set on the framed region only, so the viewer can bring it into view. */
  outlineRef?: (element: HTMLDivElement | null) => void;
}) {
  const place = {
    position: "absolute",
    left: `${region.x * 100}%`,
    top: `${region.y * 100}%`,
    pointerEvents: "none",
  } as const;

  return (
    <>
      <Box
        aria-hidden
        ref={outlineRef}
        sx={{
          ...place,
          width: `${region.width * 100}%`,
          height: `${region.height * 100}%`,
          border: 2,
          borderColor: "primary.main",
          borderRadius: 0.5,
          backgroundColor: "primary.main",
          // Translucent so the content underneath stays readable.
          opacity: 0.12,
        }}
      />
      {label != null && (
        <Box
          aria-hidden
          sx={{
            ...place,
            transform: "translateY(-100%)",
            px: 0.75,
            py: 0.25,
            bgcolor: "primary.main",
            color: "primary.contrastText",
            borderRadius: 0.5,
            fontSize: "0.7rem",
            whiteSpace: "nowrap",
          }}
        >
          {label}
        </Box>
      )}
    </>
  );
}
